(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    // LOGICA CONDIZIONALE: mostra campo ordine solo per Resi o Spedizioni
  (function() {
    var requestTypeSelect = document.querySelector('[data-conditional-order]');
    var orderField = document.querySelector('.contact-form__order-field');
    var orderInput = document.querySelector('#ContactForm-order-number');
    var requiredStar = document.querySelector('.contact-form__required-order');

    if (requestTypeSelect && orderField) {
      function toggleOrderField() {
        var selectedValue = requestTypeSelect.value;
        var showOrder = selectedValue === 'resi_rimborsi' || selectedValue === 'spedizioni_consegne';
        
        orderField.style.display = showOrder ? 'flex' : 'none';
        
        if (orderInput) {
          if (showOrder) {
            orderInput.setAttribute('required', 'required');
          } else {
            orderInput.removeAttribute('required');
          }
          if (requiredStar) {
            requiredStar.style.display = showOrder ? 'inline' : 'none';
          }
        }
      }
      
      requestTypeSelect.addEventListener('change', toggleOrderField);
      toggleOrderField();
    }
  })();

  // PREPARATO PER KLAVIYO
  (function() {
    var form = document.querySelector('[data-contact-form]');
    var emailInput = document.querySelector('.contact-form__email-input');
    var marketingCheckbox = document.querySelector('.contact-form__marketing-input');
    var klaviyoListId = document.querySelector('#contact-form-klaviyo-list');
    
    if (form && klaviyoListId) {
      form.addEventListener('submit', function(e) {
        var email = emailInput ? emailInput.value : '';
        var acceptsMarketing = marketingCheckbox ? marketingCheckbox.checked : false;
        var listId = klaviyoListId.value;
        
        if (email && acceptsMarketing && listId && typeof klaviyo !== 'undefined') {
          console.log('Klaviyo ready:', { email: email, listId: listId });
        }
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
